import {Injectable} from '@angular/core';
import {LoaderService} from '.';

@Injectable({
  providedIn: 'root'
})
export class LoaderProxyService {

  constructor(private loader: LoaderService) {
  }

  public numberOfItemsLoading = 0;
  private loaderDisabled = false;

  public addItemLoading() {
    this.numberOfItemsLoading++;
    this.checkLoader();
  }

  public removeItemLoading() {
    if (this.numberOfItemsLoading > 0) {
      this.numberOfItemsLoading--;
    }
    this.checkLoader();
  }


  private checkLoader() {
    if (this.numberOfItemsLoading > 0 && this.loaderDisabled === false) {
      this.loader.showLoader();
    } else {
      this.loader.hideLoader();
    }
  }

  // Overrule loader so that it is never shown
  public disableLoader() {
    this.loaderDisabled = true;
    this.checkLoader();
  }

  // Turn of overruling of loader
  public reenableLoader() {
    this.loaderDisabled = false;
    this.checkLoader();
  }

  public isLoaderDisabled() {
    return this.loaderDisabled;
  }
}
